import TermsOfService from './TermsOfService';

export default TermsOfService;